import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingDairyManureStorage } from "services";

import { FOOTPRINTING_CROP, FOOTPRINTING_DAIRY_MANURE_STORAGE } from "consts";

import { FootprintingDairyManureStoragePayload } from "models";

export const useMutateFootprintingDairyManureStorage = (
  farmId: string,
  year: number,
  payload: FootprintingDairyManureStoragePayload,
  primaryDataId?: string
) => {
  const queryClient = useQueryClient();
  return useMutation(
    {
      mutationKey: [FOOTPRINTING_DAIRY_MANURE_STORAGE],
      mutationFn: () => setFootprintingDairyManureStorage(payload, primaryDataId),
      onSuccess: async () => {
        const QKs = [
          [FOOTPRINTING_DAIRY_MANURE_STORAGE, primaryDataId],
          [FOOTPRINTING_CROP, farmId, year],
        ];
        await Promise.all(QKs.map((QK) => queryClient.invalidateQueries({ queryKey: QK })));
        await Promise.all(QKs.map((QK) => queryClient.refetchQueries({ queryKey: QK })));
      },
    },
    queryClient
  );
};
